/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationWithRelations } from './publicationWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: InteractionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface InteractionWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    type: InteractionWithRelations.TypeEnum;
    publicationId: string;
    userId: number;
    publication?: PublicationWithRelations;
    user?: UserWithRelations;
}
export namespace InteractionWithRelations {
    export type TypeEnum = 'LIKE' | 'WELCOME' | 'CONGRATULATION';
    export const TypeEnum = {
        Like: 'LIKE' as TypeEnum,
        Welcome: 'WELCOME' as TypeEnum,
        Congratulation: 'CONGRATULATION' as TypeEnum
    };
}


